





















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PageModal from '../modal/PageModal.vue';
import { ContinentLocale, FooterLink, Locale } from '../../plugins/configuration/types/configuration';
import RegionSwitcherModal from './RegionSwitcherModal.vue';
import BaseAppModal from '../modal/BaseAppModal.vue';

@Component({
  components: { RegionSwitcherModal, BaseAppModal, PageModal },
})
export default class RegionSwitcher extends Vue {
  name = 'RegionSwitcher';

  showModal = false;

  showAlert = false;

  selectedLocale: Locale = null;

  onAlertCancelClick(): void {
    this.showModal = false;
    this.showAlert = false;
  }

  onAlertAcceptClick(hideForever: boolean): void {
    this.showModal = false;
    this.showAlert = false;

    if (this.selectedLocale !== null) {
      let targetUrl = this.selectedLocale.url;

      if (hideForever) {
        targetUrl = `${targetUrl + (targetUrl.match(/\?/) ? '&' : '?')}hideSwitcherModalForever=1`;
      }

      window.location.replace(targetUrl);
    }
  }

  onCountryLocaleClick(locale: Locale): void {
    this.selectedLocale = locale;

    if (
      locale.showInfoModal
      && this.$api.data.customer !== null
      && this.$api.data.customer.show_region_switcher_modal
    ) {
      this.showModal = false;
      this.showAlert = true;

      return;
    }

    window.location.replace(locale.url);
  }

  openRegionSwitcher(): void {
    this.showModal = true;
  }

  hideRegionSwitcher(): void {
    this.showModal = false;
  }

  get activeLanguage(): string {
    for (const key in this.$api.data.routes.locales) {
      if (Object.prototype.hasOwnProperty.call(this.$api.data.routes.locales, key)) {
        const matchedLocale = this.$api.data.routes.locales[key].find((locale) => locale.active);

        if (matchedLocale !== undefined) {
          return matchedLocale.name;
        }
      }
    }

    return undefined;
  }

  get globalLocales(): Locale[] {
    return this.$api.data.routes.locales.Global;
  }

  get asiaLocales(): Locale[] {
    return this.$api.data.routes.locales['Asia Pacific'];
  }

  get southAmericaLocales(): Locale[] {
    return this.$api.data.routes.locales['South America'];
  }

  get northAmericaLocales(): Locale[] {
    return this.$api.data.routes.locales['North America'];
  }

  get europeanLocales(): Locale[] {
    return this.$api.data.routes.locales.Europe;
  }

  get continents(): ContinentLocale {
    return this.$api.data.routes.locales;
  }
}
